//  @flow

import React from 'react';
import { withTranslation } from 'react-i18next';
//  $Ignore
import { bindActionCreators } from 'redux';
//  $Ignore
import { connect } from 'react-redux';

import FormManager from '../../Components/FormManager';
import InputManager from '../../Components/InputManager';
import Button from '../../Components/Button';
import Alert from '../../Components/Alert';

import { contactToUs, setAlertStatus } from '../../actions/contactUsForm';
import { validateEmail, validateMobile } from '../../helpers/helper';

type inputContactParams = {
  name: string,
  mobile: string,
  email: string,
  message: string
};
type FormProps = {
  contactToUs: (params: inputContactParams) => void,
  setAlertStatus: () => void,
  className: string
};

type FormState = {
  isLoading: boolean,
  alertActive: boolean,
  sentSuccess: boolean
};

class NewForm extends React.Component<FormProps, FormState> {
  constructor(props: FormProps) {
    super(props);

    this.state = {
      isLoading: false,
      alertActive: false,
      sentSuccess: false
    };
  }

  toggleLoading = () => {
    this.setState(prevState => ({ isLoading: !prevState.isLoading }));
  };

  validateName = (val: string) => val.trim().length < 3;
  validateEmail = (val: string) => !validateEmail(val.trim());
  validatePhone = (val: string) => !validateMobile(val.trim());
  validateText = (val: string) => val.trim().length <= 0;

  onSubmit = async (data, resetForm) => {
    Object.assign(data, {
      origin: 'contact_page'
    });
    try {
      this.toggleLoading();
      await this.props.contactToUs(data);
      this.toggleLoading();

      resetForm();
      this.setSuccess(true);
      this.setAlert();
    } catch (err) {
      this.setSuccess(false);
      this.toggleLoading();
      this.setAlert();
    }
  };

  setSuccess = (status: boolean) => {
    this.setState({ sentSuccess: status });
  };

  setAlert = () => {
    this.setState({ alertActive: true });
    setTimeout(() => {
      this.setState({ alertActive: false });
    }, 3000);
  };

  render = () => {
    const { t, className = '' } = this.props;

    return (
      <div className={`conatct-form-container ${className}`}>
        <div className="contact-form-content">
          <p className="contact-form-heading">{t('contactformHeading')}</p>
          {this.state.alertActive && (
            <Alert
              title={
                this.state.sentSuccess
                  ? t('alertSuccessTitle')
                  : t('alertFailedTitle')
              }
              type={this.state.sentSuccess ? 'success' : 'failed'}
            />
          )}
          <FormManager className="conatct-form" onSubmit={this.onSubmit}>
            <InputManager
              id="name"
              placeholder={t('inputName')}
              className="contact-form-field"
              value={this.state.name}
              validate={this.validateName}
              required={true}
              emptyText={t('nameEmptyText')}
              invalidText={t('nameInvalidText')}
            />

            <InputManager
              id="email"
              placeholder={t('inputEmail')}
              className="contact-form-field"
              value={this.state.email}
              validate={this.validateEmail}
              required={true}
              emptyText={t('emailEmptyText')}
              invalidText={t('emailInvalidText')}
            />

            <InputManager
              id="phone"
              placeholder={t('inputPhone')}
              className="contact-form-field"
              value={this.state.mobile}
              validate={this.validatePhone}
              required={true}
              emptyText={t('phoneEmptyText')}
              invalidText={t('phoneInvalidText')}
            />

            <InputManager
              id="message"
              type="textarea"
              placeholder={t('inputMessage')}
              className="contact-form-field-area"
              value={this.state.message}
              validate={this.validateText}
              required={true}
              emptyText={t('msgEmptyText')}
              invalidText={t('msgInvalidText')}
            />

            <Button
              autoSize
              className="contact-submit-btn"
              loading={this.state.isLoading}
              type="submit"
              text={t('sendButton')}
            />
          </FormManager>
        </div>
      </div>
    );
  };
}

const mapStateToProps = state => ({
  alertStatus: state.contact.alertStatus
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      contactToUs,
      setAlertStatus
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(NewForm));



// WEBPACK FOOTER //
// ./src/Pages/Contact/ContactForm.js